import From from 'array.from'

const Questions = Questions || {}
const ClassNames = {
  open: 'is-open',
  active: 'is-active',
  done: 'is-done',
  slideOut: 'slide-out'
};

(function (context) {
  let activeOverlay = false
  let activeQuestion
  let activeFeedback
  let activeDiscussion

  context.init = () => {
    context.bindButtons()
  }

  context.bindButtons = () => {
    const openQuestion = document.getElementsByClassName('discussion__link')
    const closeQuestion = document.getElementsByClassName('question-overlay__close')
    const option = document.getElementsByClassName('options__option')
    const feedbackNext = document.getElementsByClassName('feedback__next')
    const discussionClose = document.getElementsByClassName('overlay-discussion__close')

    // Bind open buttons
    From(openQuestion).forEach((element) => {
      element.addEventListener('click', function (e) {
        context.openQuestion(e, this)
      })
    })

    // Bind close buttons
    From(closeQuestion).forEach((element) => {
      element.addEventListener('click', () => { context.closeQuestion() })
    })

    // Bind close buttons
    From(option).forEach((element) => {
      element.addEventListener('click', () => { context.toggleOption(element, activeQuestion, activeFeedback) })
    })

    From(feedbackNext).forEach((element) => {
      element.addEventListener('click', () => { context.toggleOption(element, activeFeedback, activeDiscussion) })
    })

    From(discussionClose).forEach((element) => {
      element.addEventListener('click', () => {
        context.closeQuestion()
      })
    })

    // Bind escape key to close
    document.addEventListener('keyup', (e) => {
      if (e.code === 'Escape') context.closeQuestion(e)
    })
  }

  context.openQuestion = (e, self) => {
    activeOverlay = document.getElementById(self.dataset.open)
    activeOverlay.classList.add(`question-overlay--${ClassNames.open}`)

    activeQuestion = activeOverlay.children[1]
    activeFeedback = activeOverlay.children[2]
    activeDiscussion = activeOverlay.children[3]

    context.slideInNextStep(false, activeQuestion)
    context.toggleBodyScroll(true)

    e.stopPropagation()
  }

  context.closeQuestion = () => {
    if (activeOverlay) {
      activeOverlay.classList.remove(`question-overlay--${ClassNames.open}`)
      activeQuestion.classList.remove(`question--${ClassNames.active}`)
      context.toggleBodyScroll(false)
      activeOverlay = false
      context.resetExercise()
    }
  }

  context.resetExercise = () => {
    activeQuestion.classList.remove(ClassNames.slideOut, ClassNames.active)
    activeFeedback.classList.remove(ClassNames.slideOut, ClassNames.active)
    activeDiscussion.classList.remove(ClassNames.active)

    document.getElementsByClassName(`options__option ${ClassNames.active}`)[0].classList.remove(ClassNames.active)
    document.getElementsByClassName(`feedback__next ${ClassNames.active}`)[0].classList.remove(ClassNames.active)
  }

  context.toggleBodyScroll = (off) => {
    document.body.style.overflow = off ? 'hidden' : 'auto'
  }

  context.toggleOption = (self, currElement, nextElement) => {
    self.classList.add(ClassNames.active)
    context.slideInNextStep(currElement, nextElement)
  }

  context.slideInNextStep = (currElement, nextElement) => {
    if (currElement) {
      window.setTimeout(() => (currElement.classList.add(ClassNames.slideOut)), 400)
    }

    window.setTimeout(() => (nextElement.classList.add(ClassNames.active)), currElement ? 800 : 400)
  }
})(Questions)

document.addEventListener('DOMContentLoaded', () => {
  Questions.init()
})



// WEBPACK FOOTER //
// ./assets/js/index.js